import * as React from "react";
import { useResetRecoilState } from "recoil";

import { useKey } from "react-use";
import { Fab, Tooltip } from "@mui/material";
import { DeleteOutlineOutlined } from "@mui/icons-material";
import { uniq } from "lodash";
import {
  TUseXElement,
  useXElementUpdater,
  USE_X_ELEMENT,
} from "../../../hooks/useXElement";
import { useXPageUpdater } from "../../../hooks/useXPage";
import { TComponentType } from "../../../utils/types/common/components.types";
import {
  isCommon,
  USE_X_COMMON,
  useXCommonChildren,
  getRef,
} from "../../../hooks/useXCommon";
import { useSaveData } from "../../../hooks/useSaveData";
import { X_PAGE_SETTINGS } from "./XGUIHeader";

export const XGUIActionDeleteButton: React.FC<{
  selectedElement?: TUseXElement<any>;
  setSelectedIndex: (id: null) => void;
}> = ({ selectedElement = X_PAGE_SETTINGS, setSelectedIndex }) => {
  const saveData = useSaveData();

  // TO REMOVE THE ELEMENT FROM THE TREE
  const setPage = useXPageUpdater();

  // TO REMOVE THE ELEMENT FROM HIS PARENT
  const setParent = useXElementUpdater(selectedElement.childOf ?? "");

  const resetXCommonElement = useResetRecoilState(
    USE_X_COMMON(selectedElement.index)
  );

  const { xChildren, setXChildren } = useXCommonChildren(
    selectedElement.index as any
  );

  // DELETE THE ATOM
  const resetXpageElement = useResetRecoilState(
    USE_X_ELEMENT(selectedElement.index)
  );

  const deleteElement = async (showDialog = true) => {
    if (showDialog && !confirm("Voulez-vous vraiment supprimer cet element?")) {
      return;
    } else {
      /**
       * save the current pages data for safety
       */
      const savedData = await saveData();

      if (isCommon(selectedElement.index)) {
        const parentID = getRef(selectedElement.index);

        if (!parentID || !savedData || !savedData["commons"]) return;

        const old: TComponentType[] = (savedData["commons"] ?? []).filter(
          (e: TComponentType) =>
            e.config ? e.config.index.startsWith(parentID) : false
        );

        console.log("ELEMENT =>", selectedElement, "CHILDREN =>", xChildren);

        setXChildren(() => {
          const element = old.find((el) =>
            el.config ? el.config.index === selectedElement.index : false
          );

          if (!element) return old;

          let elementToRemoveIndexes: string[] = [];

          if (element.config) {
            elementToRemoveIndexes.push(element.config.index);
          }

          const getElementToRemove = (index: string) =>
            old.forEach((e) => {
              if (e.config) {
                if (
                  e.config.childOf === index &&
                  !elementToRemoveIndexes.includes(e.config.index)
                ) {
                  elementToRemoveIndexes.push(e.config.index);
                }
              }
            });

          old.forEach((e) => {
            if (
              e.config &&
              elementToRemoveIndexes.includes(e.config.childOf ?? "")
            ) {
              elementToRemoveIndexes.push(e.config.index);
              getElementToRemove(e.config.index);
            }
          });

          elementToRemoveIndexes = uniq(elementToRemoveIndexes);

          return old.filter((child) => {
            if (!child.config) return true;

            if (elementToRemoveIndexes.includes(child.config.index)) {
              return false;
            }

            return true;
          });
        });

        resetXCommonElement();
      } else {
        // DELETE ELEMENT
        setPage((page) => {
          // TODO : SAME AS COMMON FOR THIS

          return (page as TComponentType[]).filter((section) => {
            if (!section.config) return true;

            let keep = section.config.index !== selectedElement.index;

            if (keep && selectedElement.hasChildren) {
              keep = !selectedElement.elementsIndexes.includes(
                section.config.index
              );
            }

            return keep;
          });
        });

        // REMOVE FROM PARENT
        if (selectedElement.childOf) {
          setParent((old) => {
            // TODO : SAME AS COMMON FOR THIS

            return {
              ...old,
              elementsIndexes: old.elementsIndexes.filter(
                (index) => index !== selectedElement.index
              ),
            };
          });
        }

        // DELETE
        resetXpageElement();
      }

      // DISABLE THE POPUP
      setSelectedIndex(null);
    }
  };

  useKey("Backspace", (e) => {
    if (e.shiftKey) deleteElement();
  });

  return (
    <Tooltip
      key={"delete-btn"}
      title={"Supprimer Cet Element"}
      placement="bottom"
    >
      <Fab
        size="small"
        color="secondary"
        sx={{
          pointerEvents: "all",
          borderRadius: 0,
          boxShadow: "0 5px 10px -5px rgba(0, 0, 0, 0.25)",
          // bgcolor: SECONDARY_COLOR,

          // "&:hover": {
          //   bgcolor: () => darken(SECONDARY_COLOR, 0.2),
          // },
        }}
        onClick={async () => await deleteElement()}
      >
        <DeleteOutlineOutlined sx={{ color: "white" }} />
      </Fab>
    </Tooltip>
  );
};
